import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import ReactGA from "react-ga4";
import debounce from "lodash.debounce";
//
const Shop = () => {
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [evento, setEvento] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [product, setProduct] = useState([]);
  const [temProdutos, setTemProdutos] = useState(false);
  const [uniqueEvents, setUniqueEvents] = useState([]);
  const { clearCart, cartItems } = useCart();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  //GA
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "home_da_loja",
    });

    ReactGA.event({
      category: "visita_a_loja",
      action: "acesso_area_loagada",
      label: user.nome, // optional
    });
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product`
        );
        const products = response.data.data.reverse();

        // Filtro inicial para assessoria (atletaId deve ser igual ao user.id)
        const filteredByAtletaId =
          user.perfil === "Assessoria"
            ? products.filter((product) => product.atletaId === user.id)
            : products.filter((product) => !product.atletaId); // Filtro para não mostrar produtos com atletaId se não for "Assessoria"

        const semBrindes = filteredByAtletaId.filter(
          (product) => !product.tags.toLowerCase().includes("brinde")
        );

        setProduct(semBrindes);
        setFilteredProducts(semBrindes);

        const events = semBrindes.map((product) => product.evento);
        const uniqueEvents = Array.from(new Set(events)).sort((a, b) =>
          b.localeCompare(a)
        );
        setUniqueEvents(uniqueEvents);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [user.id, user.perfil]);

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.priceInCents * item.quantity,
    0
  );

  const filterProducts = () => {
    if (!Array.isArray(product)) {
      console.error("Products is not an array:", product);
      return;
    }

    let filtered = [...product];

    // Filtro por evento
    if (evento !== "") {
      filtered = filtered.filter((product) => product.evento === evento);
    }

    // Filtro por termos de pesquisa
    if (searchTerm !== "") {
      const terms = searchTerm
        .toLowerCase()
        .split(" ")
        .filter((term) => term !== "");
      filtered = filtered.filter((product) =>
        terms.every(
          (term) =>
            product.evento.toLowerCase().includes(term) ||
            product.tags.toLowerCase().includes(term) ||
            product.local.toLowerCase().includes(term)
        )
      );
    }

    setFilteredProducts(filtered);
  };

  useEffect(() => {
    filterProducts();
  }, [product, evento, searchTerm]);

  useEffect(() => {
    setTemProdutos(cartItems.length > 0);
  }, [cartItems]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    debouncedSendSearchTerm(e.target.value);
  };

  const sendSearchTermToGA = (term) => {
    ReactGA.event({
      category: "Pesquisa",
      action: "Usuário pesquisou",
      label: term,
    });
  };

  const debouncedSendSearchTerm = useCallback(
    debounce((term) => {
      if (term.trim() !== "") {
        sendSearchTermToGA(term);
      }
    }, 500),
    []
  );

  return (
    <div className="p-4 max-w-[1300px] mx-auto mt-16">
      <div className="text-center text-lg mb-4 ml-2 lg:text-center">
        <a>Olá, {user.nome}. </a>
      </div>
      <div className="filters flex justify-between mb-6">
        <div className="form-control flex">
          <label className="label">
            <span className="label-text">Escolher partida</span>
          </label>
          <select
            value={evento}
            onChange={(e) => setEvento(e.target.value)}
            className="select select-bordered w-full max-w-xs"
          >
            <option value="">Tudo</option>
            {uniqueEvents.map((event) => (
              <option key={event} value={event}>
                {event}
              </option>
            ))}
          </select>
        </div>
        <div className="form-control flex mx-auto ml-1">
          <label className="label">
            <span className="label-text">Filtrar por palavras</span>
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Digite para filtrar"
            className="input input-bordered w-full max-w-xs"
          />
          <span className="text-xs mt-1 text-gray-400">
            Ex.: seleção, vnl, brait, minas, final, paulista, uberlândia etc.{" "}
          </span>
        </div>

        {temProdutos ? (
          <div className="fixed top-[74px] left-4 z-10">
            <button
              onClick={() => {
                navigate("/ar/cart");
              }}
              className="bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-md"
            >
              Total: R$
              {(totalPrice / 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
              })}
            </button>
          </div>
        ) : null}
      </div>

      {filteredProducts.length === 0 ? (
        <div className="text-center text-lg mt-4">
          Fotos não localizadas{" "}
          {/* <p className="my-4">
            Pode haver foto sua, mas seu nome ainda não foi cadastrado na busca.{" "}
          </p> */}
        </div>
      ) : (
        <>
          {loading && <Spinner />}
          <ProductCard product={filteredProducts} />
        </>
      )}
    </div>
  );
};

export default Shop;
